import { Controller } from "@hotwired/stimulus"
import trainLines from "../data/kyushu_train_lines.json"

const OTHER = "その他（自由入力）"

type TransportMaster = {
  lines: string[]
  stations: Record<string, string[]>
}

const transportMaster = trainLines as TransportMaster

export default class extends Controller<HTMLElement> {
  static targets = ["lineSelect", "lineOther", "stationSelect", "stationOther"]
  static values = { initialLine: String, initialStation: String }

  declare readonly lineSelectTarget: HTMLSelectElement
  declare readonly lineOtherTarget: HTMLInputElement
  declare readonly stationSelectTarget: HTMLSelectElement
  declare readonly stationOtherTarget: HTMLInputElement
  declare readonly initialLineValue: string
  declare readonly initialStationValue: string

  connect() {
    this.replaceOptions(this.lineSelectTarget, transportMaster.lines, "路線を選択")
    this.initializeLine()
  }

  changeLine() {
    if (this.lineSelectTarget.value === OTHER) {
      this.showOtherLine("")
      this.showOtherStation("")
      return
    }

    const line = this.lineSelectTarget.value

    this.showMasterLine()
    this.buildStationOptions(line)
    this.showMasterStation()
    this.stationSelectTarget.value = ""
  }

  changeStation() {
    if (this.stationSelectTarget.value === OTHER) {
      this.showOtherStation("")
    } else {
      this.showMasterStation()
    }
  }

  private initializeLine() {
    const line = this.initialLineValue
    const station = this.initialStationValue

    if (line === OTHER) {
      this.lineSelectTarget.value = OTHER
      this.showOtherLine("")
      this.showOtherStation(station === OTHER ? "" : station)
      return
    }

    if (line && !transportMaster.lines.includes(line)) {
      this.lineSelectTarget.value = OTHER
      this.showOtherLine(line)
      this.showOtherStation(station)
      return
    }

    this.lineSelectTarget.value = line
    this.showMasterLine()
    this.buildStationOptions(line)
    this.initializeStation(line, station)
  }

  private initializeStation(line: string, station: string) {
    const stations = transportMaster.stations[line] || []

    if (station === OTHER) {
      this.stationSelectTarget.value = OTHER
      this.showOtherStation("")
      return
    }

    if (station && !stations.includes(station)) {
      this.stationSelectTarget.value = OTHER
      this.showOtherStation(station)
      return
    }

    this.stationSelectTarget.value = station
    this.showMasterStation()
  }

  private buildStationOptions(line: string) {
    this.replaceOptions(this.stationSelectTarget, transportMaster.stations[line] || [], "駅を選択")
  }

  private replaceOptions(select: HTMLSelectElement, options: string[], placeholder: string) {
    select.replaceChildren(new Option(placeholder, ""), ...options.map((option) => new Option(option, option)))
  }

  private showMasterLine() {
    this.toggleField(this.lineSelectTarget, true)
    this.toggleField(this.lineOtherTarget, false)
  }

  private showOtherLine(value: string) {
    this.lineOtherTarget.value = value
    this.toggleField(this.lineSelectTarget, false)
    this.toggleField(this.lineOtherTarget, true)
  }

  private showMasterStation() {
    this.toggleField(this.stationSelectTarget, true)
    this.toggleField(this.stationOtherTarget, false)
  }

  private showOtherStation(value: string) {
    this.stationOtherTarget.value = value
    this.stationSelectTarget.value = OTHER
    this.toggleField(this.stationSelectTarget, false)
    this.toggleField(this.stationOtherTarget, true)
  }

  private toggleField(field: HTMLSelectElement | HTMLInputElement, enabled: boolean) {
    field.disabled = !enabled
    field.classList.toggle("hidden", !enabled)
  }
}
